// extracted by mini-css-extract-plugin
export default {"wrapper":"PieChart_wrapper__OA0H-","content":"PieChart_content__IAw7D","legend-wrapper":"PieChart_legend-wrapper__IdLGb"};